import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';

import { LOCAL_COLORS } from 'styles/constants';
import { desktopOnly, mobileOnly } from 'styles/mixins/displayMobileDesktop';

export const SectionContainer = styled.section`
  background-color: ${LOCAL_COLORS.surfaceBrandBold};
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 auto;
  padding: 0 1rem 3.5rem;

  ${MEDIA_QUERIES.smUp} {
    min-width: 460px;
    padding: 0 2rem 3.5rem;
  }

  ${MEDIA_QUERIES.lgUp} {
    max-width: 1440px;
    flex-direction: row;
    padding: 8.5rem 4.5rem;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Title = styled.h2`
  font-size: 1.5rem;
  color: ${LOCAL_COLORS.textInverse};
  line-height: 130%;
  margin-bottom: ${SPACER.small};

  ${MEDIA_QUERIES.smUp} {
    font-size: 2rem;
  }
`;

export const Subtitle = styled.div`
  color: ${LOCAL_COLORS.textInverse};
  line-height: 150%;
  margin-bottom: ${SPACER.large};
  max-width: 320px;
`;

export const OuterStepsContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${MEDIA_QUERIES.smUp} {
    width: 100%;
    flex-direction: row;
  }

  ${MEDIA_QUERIES.lgUp} {
    width: 66%;
  }
`;

export const InnerStepsContainer = styled.div`
  display: flex;
  flex-direction: row;
  max-height: 250px;
  width: 100%;
`;

export const OrangeBlock = styled.div`
  background-color: ${LOCAL_COLORS.surfaceOrange};
  flex-grow: 1;
  font-weight: 700;
  line-height: 100%;
  color: ${LOCAL_COLORS.textDefault};
  font-size: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (min-width: 371px) {
    font-size: 2rem;
  }
`;

export const DisplayNumber = styled.span`
  font-family: var(--header-font);
  font-size: 109px;
  line-height: 90%;
  padding: 0 1.25rem;
  ${MEDIA_QUERIES.smUp} {
    padding: 0 2rem;
  }
`;

export const StepsBlock = styled.div`
  background-color: ${LOCAL_COLORS.surfacePastelPurple};
  flex-grow: 2;
  padding: 3.5rem 1rem;
  white-space: nowrap;
  overflow: hidden;
`;

export const Step = styled.div`
  display: flex;
  flex-direction: row;
  color: ${LOCAL_COLORS.textDefault};
  font-size: ${({ theme }) => theme.TYPOGRAPHY.fontSize.body};
  font-weight: 700;

  ${MEDIA_QUERIES.xsUp} {
    font-size: ${({ theme }) => theme.TYPOGRAPHY.fontSize.title};
  }
`;

export const StepNumber = styled.span`
  margin-right: ${SPACER.small};
`;

export const Image = styled.div`
  flex-grow: 3;
  background-color: yellow;
  height: 250px;
`;

export const ctaStyles = css`
  display: block;
  width: 100%;
  border-radius: 56px;
  background-color: ${LOCAL_COLORS.surfaceDarkBold};
  padding: ${SPACER.base} 0;
  text-align: center;
  font-size: 0.875rem;
  font-weight: 700;
  color: ${LOCAL_COLORS.textInverse} !important;
  text-decoration: none !important;

  &:hover {
    background-color: #4a4a69;
  }
`;

export const mobileCta = css`
  ${ctaStyles};
  ${mobileOnly('block', 'lgUp')};
  margin-top: ${SPACER.x2large};

  ${MEDIA_QUERIES.smUp} {
    width: 153px;
  }
`;

export const desktopCta = css`
  ${ctaStyles};
  ${desktopOnly('block', 'lgUp')};

  width: 153px;
`;

export const imageStyles = css`
  height: 250px;
  max-width: 542px;

  ${MEDIA_QUERIES.smUp} {
    min-width: 205px;
    max-width: 343px;
  }
`;
